/* eslint-disable no-underscore-dangle */
import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {makeSelectCreate} from 'reducers/selectors/fileSelector';
import {makeSelectBasicUser} from 'reducers/selectors/userSelectors';
import {addUploadedFile, fetchFolder, fetchFolders, fetchFolderSuccess} from 'actions/categoryActions';
import history from 'utils/history';
import FileUploadModal from './FileUploadModal';
import PostsFooter from './PostFooter';
import FilesTable from './FilesTable';
import Search from './Search';
import './style.scss';
import 'styles/blog-post-edit.scss';

const basicUserSelector = makeSelectBasicUser();

const Overview = ({folderId}) => {
  const [selected, setSelected] = useState([]);

  const dispatch = useDispatch();
  const iframe = useRef();
  const posts = useSelector((state) => state.category);
  const basicUser = useSelector(basicUserSelector);
  const {insideFolder} = posts;
  const [uploadFiles, setUploadFiles] = useState(null);
  const folderState = useSelector(makeSelectCreate());
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [pageFilter, setPageFilter] = useState({
    pageSize: 200,
    pageNumber: 0,
  });

  useEffect(() => {
    setTimeout(() => fetch(), 200);
  }, [insideFolder, pageFilter, searchKey]);

  useEffect(() => {
    if (insideFolder && !breadcrumb.find((f) => f._id === insideFolder._id)) {
      setBreadcrumb([...breadcrumb, insideFolder]);
    }
  }, [insideFolder]);

  useEffect(() => {
    if (folderId) {
      setTimeout(() => dispatch(fetchFolder(folderId)), 200);
    }
  }, []);

  const fetch = () => {
    const params = {
      ...pageFilter,
    };
    if (insideFolder) {
      params.folderId = insideFolder._id;
    }
    dispatch(fetchFolders(params));
  };

  return (
    <>
      <iframe
        title="test"
        id="my_iframe"
        ref={iframe}
        style={{display: 'none'}}
      ></iframe>

      {uploadFiles && (
        <FileUploadModal
          folderState={folderState}
          breadcrumb={breadcrumb}
          selected={insideFolder}
          onClose={() => {
            setUploadFiles(false);
          }}
          onFileUpload={(file) => {
            if (file) {
              dispatch(addUploadedFile(file));
            }
          }}
        />
      )}

      <div className="tab-box">
        <div className="d-flex mob-flex">
          <div className="tab-content bg-white w-100">
            <Search
              tab={{label: 'Images'}}
              setSearchKey={setSearchKey}
              searchKey={searchKey}
              onChange={(search) => {
                const newPageFilter = {...pageFilter};
                newPageFilter.searchKey = search;
                setPageFilter(newPageFilter);
              }}
              breadcrumb={breadcrumb}
              selected={insideFolder}
              onFile={() => setUploadFiles(true)}
              onClick={(folder) => {
                if (!folder) {
                  dispatch(fetchFolderSuccess(null));
                  setBreadcrumb([]);
                } else {
                  const newBreadCrumb = [];
                  breadcrumb.every((f) => {
                    if (f._id !== folder._id) {
                      newBreadCrumb.push(f);
                      return true;
                    }
                    newBreadCrumb.push(f);
                    return false;
                  });

                  setBreadcrumb(newBreadCrumb);
                  dispatch(fetchFolderSuccess(folder));
                }
              }}
            />

            {posts.fetchSuccess && (
              <>
                <FilesTable
                  selected={selected}
                  inside={breadcrumb[0]}
                  onDoubleClick={(file) => {
                    if (file.folderType === 'FOLDER') {
                      setSearchKey('');
                      const newBreadCrumb = [...breadcrumb];
                      newBreadCrumb.push(file);
                      setBreadcrumb(newBreadCrumb);
                      dispatch(fetchFolderSuccess(file));
                      setSelected([]);
                      history.push(`/admin/images/${file.uniqueId}`);
                    }
                  }}
                  setSelected={(file) => {
                    let newSelected = [...selected];
                    const exists = newSelected.find((f) => f._id === file._id);

                    if (exists) {
                      newSelected = newSelected.filter(
                        (f) => f._id !== file._id
                      );
                    } else {
                      newSelected.push(file);
                    }
                    setSelected(newSelected);
                  }}
                  posts={posts.folders}
                  basicUser={basicUser}
                />
                {breadcrumb.length === 0 && (
                  <PostsFooter
                    pageFilter={pageFilter}
                    setPageFilter={setPageFilter}
                    count={50}
                    onChange={() => {}}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Overview;
